import React, { useEffect } from 'react';
import { useElementPosition } from '../../../hooks/useElementPosition';
import { View } from 'react-native';
import Text from '../Text';

export type TabLabelOwnProps = {
    label: string;
    width: number;
    onWidthChange: (width: number, tabValue: string) => void;
    isSelected: boolean;
    tabValue: string;
};

export type TabLabelProps = TabLabelOwnProps;

const TabLabel: React.FC<TabLabelProps> = ({ label, width, onWidthChange, isSelected, tabValue }) => {
    const { ref, onLayout, position } = useElementPosition({});
    const positionWidth = position?.width || 0;
    useEffect(() => {
        // check for significant width change.  bolding the text causes a slight width change
        if (positionWidth && width !== positionWidth && Math.abs(width - positionWidth) > 3) {
            onWidthChange(positionWidth, tabValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [positionWidth, width]);
    return (
        <View ref={ref} testID="tab-text-container">
            <Text
                variant={isSelected ? 'active-tab' : 'inactive-tab'}
                wrapText={false}
                onLayout={(e) => {
                    onLayout(e);
                    onWidthChange(e.nativeEvent.layout.width, tabValue);
                }}
            >
                {label}
            </Text>
        </View>
    );
};

export default React.memo(TabLabel);
